import type { CSSProperties } from "react";
import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { CountryCodes } from "~enums/countryCodes.ts";
import type { LabelValue } from "~types/labelValue.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  className?: string;
  disabled?: boolean;
  defaultValue?: string | { value: string; label: string }[];
  placeholder?: string;
  multiple?: boolean;
  style?: CSSProperties;
  value?: LabelValue | LabelValue[] | string;
  onChange?: (value: LabelValue | LabelValue[] | undefined) => void;
};

const SelectCountryCode = (props: Props) => {
  const { className, disabled, defaultValue, multiple, style } = props;
  const { formatMessage } = useIntl();
  const options = useMemo(
    () =>
      Object.values(CountryCodes).map((value) => ({
        value,
        label: formatMessage({ id: `countryCode.${value}` }),
      })),
    [formatMessage],
  );

  return (
    <CustomSelect
      style={{ minWidth: "250px", ...style }}
      value={props.value}
      showSearch
      optionFilterProp="label"
      defaultValue={defaultValue}
      onChange={(_, option) => {
        if (multiple) {
          props.onChange?.(option as { value: string; label: string }[]);
        } else {
          props.onChange?.(option as { value: string; label: string });
        }
      }}
      options={options}
      placeholder={props.placeholder || <FormattedMessage id="country" />}
      allowClear
      className={className}
      disabled={disabled}
      mode={multiple ? "multiple" : undefined}
    />
  );
};

export default SelectCountryCode;
